module.exports = __webpack_public_path__ + "img/balsamiq.41725ee5.svg";